<template>
    <div class="container-fluid pt-2">
        <div class="card">
            <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                    <h5>Report Sales</h5>
                </div>
            </div>
            <div class="card-body col-12">
                <div class="row">
                    <div class="col-md-12">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <!-- <h5>{{ params.divisi_name }}</h5> -->
                            <select v-model="params.divisi_id" class="form-select" style="max-width: 15rem;">
                                <option :value="null">Select Divisi</option>
                                <option v-for="option in divisiOptions" :key="option.ID" :value="option.ID">
                                    {{ option.name }}
                                </option>
                            </select>
                            <button class="btn btn-sm btn-primary" @click="data.value = {}; isform = true;"><i
                                    class="fa fa-solid fa-plus"></i>
                                Generade</button>
                        </div>
                        <DataTable :headers="headers" :items="salesClosing" :loading="loading" :total="total"
                            :params="params" @update:params="updateParams">
                            <template #item.doc_date="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                                formatDateTime(item.CreatedAt) }}</template>
                            <template #item.document_start_date="{ item }"
                                style="white-space: nowrap;word-wrap: break-word;">{{
                                    formatDateTime(item.document_start_date) }}</template>
                            <template #item.document_end_date="{ item }"
                                style="white-space: nowrap;word-wrap: break-word;">{{
                                    formatDateTime(item.document_end_date) }}</template>
                            <template #item.transaction_start_date="{ item }"
                                style="white-space: nowrap;word-wrap: break-word;">{{
                                    formatDateTime(item.transaction_start_date) }}</template>
                            <template #item.transaction_end_date="{ item }"
                                style="white-space: nowrap;word-wrap: break-word;">{{
                                    formatDateTime(item.transaction_end_date) }}</template>
                            <template #item.actions="{ item }">
                                <button :disabled="item.progress != 'DONE'" class="btn btn-sm btn-primary" @click="downloadData(item)">
                                    <i class="fa fa-solid fa-download"></i>
                                </button>&nbsp;
                                <button class="btn btn-sm btn-info" @click="cloneData(item)">
                                    <i class="fa fa-solid fa-copy"></i>
                                </button>&nbsp;
                                <button class="btn btn-sm btn-warning" @click="recalculateData(item)">
                                    <i class="fa fa-solid fa-calculator"></i>
                                </button>&nbsp;
                                <button class="btn btn-sm btn-danger" @click="deleteData(item.ID)">
                                    <i class="fa fa-solid fa-trash"></i>
                                </button>
                            </template>
                        </DataTable>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Form title="Generate Report Sales" v-if="isform" :data="data" @on-closed="isform = false; fetchSalesClosing()" />
    <View title="View Report Sales" v-if="isView" :data="data" @on-closed="isView = false" />
</template>

<script lang="ts" setup>
import { ref, reactive, onMounted, defineAsyncComponent } from 'vue'
const Form = defineAsyncComponent(() => import("./Form.vue"))
const View = defineAsyncComponent(() => import("./View.vue"))
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import DataTable from '@/components/table/DatatableDateRange.vue'
import { Modal } from 'bootstrap'
import * as sales from '@/api/services/SalesRequest'
import { useSessionStore } from '@/store/session';
const session = useSessionStore()
const isform = ref(false)
const isView = ref(false)
const data = ref<any>({})
const divisiOptions = ref<{ ID: any }[]>([])
// {{ Define SalesOrder interface }}

const headers = [
    { text: '#Act', value: 'actions' },
    { text: 'Doc No', value: 'code' },
    { text: 'Doc Date', value: 'doc_date' },
    { text: 'Divisi', value: 'divisi_name' },
    { text: 'Name', value: 'name' },
    { text: 'Progress', value: 'progress' },
    { text: 'Document Start', value: 'document_start_date' },
    { text: 'Document End', value: 'document_end_date' },
    { text: 'Transaction Start', value: 'transaction_start_date' },
    { text: 'Transaction End', value: 'transaction_end_date' },
    { text: 'Note', value: 'notes' },
]

// {{ Apply types to refs and reactive objects }}
const salesClosing = ref<any[]>([])
const loading = ref(false)
const total = ref(0)
const params = reactive<DataTableParams>({
    page: 1,
    size: 10,
    search: '',
    divisi_id: '',
    divisi_name: ''
})
function update(item: any) {
    data.value = item
    isform.value = true
}
const fetchSalesClosing = async () => {
    data.value = {}
    loading.value = true
    try {
        // Simulate API delay
        await sales.postRequest("/report-sales/list", params).then((response) => {
            salesClosing.value = response.data;
            total.value = response.total
        });

    } catch (error) {
        toast.error('Failed to fetch sales closing')
    }
    loading.value = false
}

const updateParams = (newParams: Partial<DataTableParams>) => {
    Object.assign(params, newParams)
    fetchSalesClosing()
}

const modalRef = ref<HTMLElement | null>(null) // Type the ref
let bsModal: any | null = null // Type the bootstrap modal instance as any since Modal namespace can't be used directly

onMounted(() => {
    // Initialize division options
    divisiOptions.value = session.divisionOptions();
    console.log('Initialized divisiOptions:', divisiOptions.value);
    
    // Set current user's division as default filter
    const userDivision = session.divisionOptions().find((item) => item.name === session.getUser().divisi);
    if (userDivision) {
        params.divisi_id = userDivision.ID;
        // params.divisi_name = userDivision.name;
        console.log('Set user division filter:', userDivision);
    } else {
        console.warn('Could not find user division in options');
    }
    
    if (modalRef.value) { // Check if modalRef exists
        bsModal = new Modal(modalRef.value);
    }
    
    // Initial data fetch
    fetchSalesClosing();
})

function formatDateTime(dateString: string, part: string = "-", partTime: string = " "): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    return `${dd}${part}${mm}${part}${yyyy}${partTime}${hh}:${min}`;
}

function formatDateForInput(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    // Format: YYYY-MM-DDThh:mm (format required for datetime-local input)
    return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
}

function totalSo(items: any[]) {
    return separator(items.reduce((total, item) => total + 1, 0));
}

function totalProduk(items: any[]) {
    return separator(items.reduce((total, item) => total + item.order.qty_total, 0));
}
function totalOmset(items: any[]) {
    return formatCurrency(items.reduce((total, item) => total + item.order.grand_total, 0));
}
function totalRelease(items: any[]) {
    return formatCurrency(items.reduce((total, item) => total + item.price, 0));
}

function separator(value: number) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function formatCurrency(value: number) {
    return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0
    }).format(value);
}
const deleteData = async (id: number) => {
    if (!confirm('Are you sure you want to delete this Report Sales?')) return

    loading.value = true
    try {
        await sales.postRequest("/report-sales/delete", { ID: id }).then((resp) => {
            if (resp.status === 200) {
                toast.success('Report Sales deleted successfully');
                fetchSalesClosing();
            } else {
                toast.error('Failed to delete Report Sales');
            }
        })

    } catch (error: any) {
        toast.error(error.message || 'Failed to delete Report Sales');
    } finally {
        loading.value = false
    }
}

const cloneData = (item: any) => {
    console.log('Original item to clone:', item)
    console.log('Available divisiOptions:', divisiOptions.value)
    
    // Create a deep copy of the item without the ID
    const clonedItem = JSON.parse(JSON.stringify(item))
    delete clonedItem.ID // Remove ID so it will be treated as a new record
    
    // Ensure dates are properly formatted for the form
    if (clonedItem.document_start_date) {
        clonedItem.document_start_date = formatDateForInput(clonedItem.document_start_date)
    }
    if (clonedItem.document_end_date) {
        clonedItem.document_end_date = formatDateForInput(clonedItem.document_end_date)
    }
    if (clonedItem.transaction_start_date) {
        clonedItem.transaction_start_date = formatDateForInput(clonedItem.transaction_start_date)
    }
    if (clonedItem.transaction_end_date) {
        clonedItem.transaction_end_date = formatDateForInput(clonedItem.transaction_end_date)
    }
    
    // Ensure divisi is properly set
    if (clonedItem.divisi_id) {
        // Try to find the divisi by ID
        const foundDivisi = divisiOptions.value.find(d => d.ID === clonedItem.divisi_id)
        console.log('Found divisi by ID:', foundDivisi)
        
        if (foundDivisi) {
            clonedItem.divisi = foundDivisi
            // Also set divisi_name for display purposes
            clonedItem.divisi_name = foundDivisi.name
        } else {
            console.warn('Could not find divisi with ID:', clonedItem.divisi_id)
        }
    } else if (clonedItem.divisi_name) {
        // If we have a divisi_name but no divisi object, try to find it by name
        const foundDivisi = divisiOptions.value.find(d => d.name === clonedItem.divisi_name)
        console.log('Found divisi by name:', foundDivisi)
        
        if (foundDivisi) {
            clonedItem.divisi = foundDivisi
            clonedItem.divisi_id = foundDivisi.ID
        }
    }
    
    console.log('Cloned item after processing:', clonedItem)
    
    // Set the data and open the form
    data.value = clonedItem
    isform.value = true
}

const recalculateData = async (item: any) => {
    if (!confirm('Are you sure you want to recalculate this Report Sales?')) return

    loading.value = true
    try {
        await sales.postRequest("/report-sales/recalculate", { ID: item.ID }).then((resp) => {
            if (resp.status === 200) {
                toast.success('Report Sales recalculation started');
                fetchSalesClosing();
            } else {
                toast.error('Failed to start recalculation');
            }
        })

    } catch (error: any) {
        toast.error(error.message || 'Failed to start recalculation');
    } finally {
        loading.value = false
    }
}

const downloadData = async (data: any) => {
    if (!confirm('Are you sure you want to download this Report Sales?')) return

    loading.value = true
    try {
        // Simulate API delay
        const prms = { ...params }
        prms.size = 100000
        prms.ID = data.ID
        try {
            const response = await sales.getDownload("/report-sales/download/xlsx", prms);
            // Create blob from response data
            const blob = new Blob([response], { type: 'application/vnd.ms-excel' });
            // Create download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', data.code +'-'+data.name + '.xlsx');
            // Trigger download
            document.body.appendChild(link);
            link.click();
            // Cleanup
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
        } catch (error) {
            toast.error('Failed to download file. Please try again.');
        }

    } catch (error) {
        toast.error('Failed to fetch delivery')
    }
    loading.value = false
}

</script>